import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { MultiPin } from "@mapmycustomers/shared/types/map";
import {
  EntitiesSupportingMultiPin,
  EntityTypesSupportingMultiPin,
} from "@mapmycustomers/shared/types/map/types";
import RangeModel from "@mapmycustomers/shared/types/viewModel/internalModel/RangeModel";
import SortModel from "@mapmycustomers/shared/types/viewModel/internalModel/SortModel";
import ListResponse from "@mapmycustomers/shared/types/viewModel/ListResponse";
import PlatformFilterModel from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import { AreaSearchQuery } from "@app/types/filters/AreaSearchQuery";

export const showMultiPinRecords = createAsyncAction(
  "@dashboard/showMultiPinRecords/request",
  "@dashboard/showMultiPinRecords/success",
  "@dashboard/showMultiPinRecords/failure"
)<
  {
    multiPin: MultiPin;
    platformFilterModel?: PlatformFilterModel;
    visibleEntities: EntityTypesSupportingMultiPin[];
  },
  {
    address?: string;
  },
  unknown
>();

export const hideMultiPinRecords = createAction("@dashboard/hideMultiPinRecords")<void>();

export const fetchMultiPinRecords = createAsyncAction(
  "@dashboard/fetchMultiPinRecords/request",
  "@dashboard/fetchMultiPinRecords/success",
  "@dashboard/fetchMultiPinRecords/failure"
)<
  {
    request: {
      range?: RangeModel;
      search?: string;
    };
  },
  ListResponse<EntitiesSupportingMultiPin>,
  unknown
>();

export const applyRecordsListSettings = createAction("@dashboard/applyMultiPinRecordsSettings")<{
  sort?: SortModel;
}>();

export const updateMultiPinRecordsSorting = createAction(
  "@dashboard/updateMultiPinRecordsSorting"
)<{
  query?: AreaSearchQuery;
  sort: SortModel;
}>();

export const downloadMultiPinRecords = createAction("@dashboard/downloadMultiPinRecords")<{}>();

export type MultiPinRecordsActions = ActionType<
  | typeof applyRecordsListSettings
  | typeof downloadMultiPinRecords
  | typeof fetchMultiPinRecords
  | typeof hideMultiPinRecords
  | typeof showMultiPinRecords
  | typeof updateMultiPinRecordsSorting
>;
